import { all, spawn, call } from "redux-saga/effects";

import loadConfigurationFlow from "./loadConfigurationFlow";
import loadStudentFlow from "./loadStudentFlow";
import dismissSystemMessageFlow from "./dismissSystemMessageFlow";
import startCertificationTestExecutionFlow from "./startCertificationTestExecutionFlow";
import startCertificationTestAbilityExecutionFlow from "./startCertificationTestAbilityExecutionFlow";
import getNextCertificationTestAbilityItemFlow from "./getNextCertificationTestAbilityItemFlow";
import saveCertificationTestAbilityItemExecutionAnswerFlow from "./saveCertificationTestAbilityItemExecutionAnswerFlow";
import endCertificationTestAbilityExecutionAnswerFlow from "./endCertificationTestAbilityExecutionAnswerFlow";
import closeCertificationTestAbilityExecutionFlow from "./closeCertificationTestAbilityExecutionFlow";
import checkCertificationTestResultFlow from "./checkCertificationTestResultFlow";
import loadLocalizedLabelsFlow from "./loadLocalizedLabelsFlow";
import startCertificationTestTastingAbilityExecutionFlow from "./startCertificationTestTastingAbilityExecutionFlow";
import oldPlayItemAudioFlow from "./old-flows/playItemAudioFlow";
import { endOldRecordByTimeoutFlow, endOldRecordFlow, startOldRecordFlow } from "./old-flows/recordFlow";
import { logError } from "../util";

export default function* () {
  const sagas = [
    loadConfigurationFlow,
    loadStudentFlow,
    startCertificationTestExecutionFlow,
    startCertificationTestAbilityExecutionFlow,
    getNextCertificationTestAbilityItemFlow,
    saveCertificationTestAbilityItemExecutionAnswerFlow,
    endCertificationTestAbilityExecutionAnswerFlow,
    closeCertificationTestAbilityExecutionFlow,
    checkCertificationTestResultFlow,
    dismissSystemMessageFlow,
    loadLocalizedLabelsFlow,
    startCertificationTestTastingAbilityExecutionFlow,
    oldPlayItemAudioFlow,
    startOldRecordFlow,
    endOldRecordFlow,
    endOldRecordByTimeoutFlow,
  ];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            logError({ flow: "ROOT_SAGA", error });
          }
        }
      })
    )
  );
}
